import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  height: ${props => (props.height ? props.height : 220)}px;
  outline: none;

  .header-title {
    position: relative;
    padding-right: 8px;
    font-weight: bold;
    font-size: 15px;
    color: ${colors.black};
    opacity: 0.5;
  }


  &::-webkit-scrollbar { width: 0!important }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }

  [class*='MuiLinearProgress-colorPrimary-'] {
    background-color: rgb(196, 227, 199)!important;
  }

  [class*='MuiLinearProgress-barColorPrimary-'] {
    background-color: #62bb45!important;
  }

  .scrollList::-webkit-scrollbar { width: 0!important }
  .scrollList { overflow: -moz-scrollbars-none!important; outline: none!important;}
  .scrollList { -ms-overflow-style: none!important; }

  .rowCallLogs { position: relative!important; top: 0px!important; height: auto!important; min-height: 20px;}
  .list-header {
    position: relative!important;
    top: 0px!important;
    background-color: ${colors.white};
    margin: 5px 0px 5px 0px!important;

    .line-header {
      position: relative!important;
      top: 0px!important;
      margin: 0!important;
    }
  }
`;

export const SectionHeader = lib.styled.div`
  height: 30px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  .line {
    height: 1px;
    background-color: ${colors.lightGray06};
    flex: 1;
  }

  span {
    padding-left: 8px;
    padding-right: 8px;
    font-weight: bold;
    font-size: 12px;
    color: ${colors.black};
    opacity: 0.5;
  }
`;
